import React from 'react';
import styled from 'styled-components';
import { Colors, Breakpoints } from '@style/Variables';
import { TextStyle } from '@client/style/TextStyles';
import Link from '@core/PageSwitch/Link';
import Site from '@client/store/Site';
import Functions from '@client/style/Functions';
import SoMeIcon from '../SoMeIcon';
import WaveDivider from '../Divider/WaveDivider';

const FooterContainer = styled.div<{ $bg?: string; $fg?: string }>`
	background-color: ${props => props.$bg || Colors.footerDarkBackground};
	color: ${props => props.$fg || Colors.lightText};
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: stretch;
	position: relative;
	z-index: 1;
	overflow: hidden;
	flex: 1 0 auto;
	${TextStyle.family('title')}
`;

const FollowUs = styled.div`
	text-align: center;
	padding-top: 130px;
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p3')}
	padding-bottom: 70px;
	${Functions.breakpoint(Breakpoints.mobile)} {
		${TextStyle.size('h6')}
	}
`;

const AllRights = styled.div`
	text-align: center;
	${TextStyle.family('title')}
	${TextStyle.size('large')}
	padding-bottom: 50px;
`;

const FooterSoMeBar = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	flex-direction: row;
	padding-bottom: 150px;
`;

const StyledLink = styled(Link)`
	width: 72px;
	height: 72px;

	${Functions.breakpoint(Breakpoints.mobile)} {
		width: 120px;
		height: 120px;
	}

	svg {
		width: 48px;
		height: 48px;
	}

	svg path {
		fill: currentColor;
	}
`;

export default function SimpleFooter(data: { optional?: { url: string; socialMediaChannel: string }[] }) {
	const footer = Site.use(state => state.footer);
	let SoMeData;

	if (data.optional && data.optional.length > 0) {
		SoMeData = data.optional;
	} else {
		SoMeData = footer.socialMediaBar;
	}

	return (
		<>
			<WaveDivider fg={footer.simpleFooterBgColorLink.color} />
			<FooterContainer
				className='footer colorWrapperAnimatedModule'
				$bg={footer.simpleFooterBgColorLink.color}
				$fg={footer.simpleFooterBgColorLink.contrastColor}
			>
				<FollowUs>Følg med for mere</FollowUs>
				<FooterSoMeBar>
					<>
						{SoMeData.map((entry, index) => {
							return (
								<StyledLink key={index} data={{ link: entry.url }}>
									<SoMeIcon icon={entry.socialMediaChannel} />
								</StyledLink>
							);
						})}
					</>
				</FooterSoMeBar>
				<AllRights>Smukfest - All rights reserved</AllRights>
			</FooterContainer>
		</>
	);
}
